import {
  Badge,
  Box,
  Stack,
  Typography,
  alpha,
  badgeClasses,
  styled,
  useTheme,
} from "@mui/material"
import {
  CalendarIcon,
  type IconUrlsProps,
  InternalLinkBox,
  formatNumber,
  noDecimalsFormatOptions,
} from "@pharmupp/p3-front-commons"

export function NotificationLinkCard({
  notificationLink = "",
  notificationCount,
}: {
  notificationLink: string | undefined
  notificationCount: number
}) {
  const theme = useTheme()
  // intenteded use of double negation do infer canNavigate
  const canNavigate = !!notificationLink
  return (
    <InternalLinkBox
      to={notificationLink}
      leftIcon={NotificationIcon}
      title={
        <NotificationTitle
          notificationCount={formatNumber(
            notificationCount,
            noDecimalsFormatOptions,
          )}
        />
      }
      topLabel="Suivre mes"
      bgcolor={theme.palette.common.white}
      slotProps={{
        linkBox: {
          topLabel: {
            variant: "14px",
            fontWeight: 500,
            sx: {
              color: theme.palette.primary.main,
            },
          },
        },
        card: {
          sx: {
            pointerEvents: canNavigate ? undefined : "none",
          },
        },
      }}
    />
  )
}

const NotificationIcon = (props: IconUrlsProps) => {
  const theme = useTheme()
  return (
    <NotificationIconContainer>
      <CalendarIcon {...props} color={theme.palette.common.orange} />
    </NotificationIconContainer>
  )
}

const NotificationIconContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  border: `1px solid ${theme.palette.common.orange}`,
  backgroundColor: alpha(theme.palette.common.orange, 0.1),
  borderRadius: theme.spacing(1),
}))

const NotificationTitle = ({ notificationCount }: { notificationCount: string }) => (
  <Stack direction="row" alignItems="center" gap={2}>
    <Title>Actions à mener</Title>
    <BadgeSyled badgeContent={notificationCount} />
  </Stack>
)

const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.common.darkBlue,
}))

Title.defaultProps = {
  variant: "16px",
}

const BadgeSyled = styled(Badge)(({ theme }) => ({
  [`& .${badgeClasses.badge}`]: {
    color: theme.palette.common.white,
    background: theme.palette.common.orange,
  },
}))
